import { confirm } from "devextreme/ui/dialog"
import http from "network/HTTPClient"
//export const baseUrl = "http://localhost/payroll/api/public/api/"
//export const baseUrl = "http://localhost/payroll_api/public/api/"
export const baseUrl = "https://mgt.hrd-be.pancasolusibisnis.com/api"
//export const baseUrl = "https://pancasolusibisnis.com/payroll_api/public/api/"
window.imageCollection = []
export const dateToString = (value, yyyy, mm, dd) => {
    yyyy = value.getFullYear()
    mm = value.getMonth() + 1
    dd = value.getDate()
    if (dd < 10) dd = "0" + dd
    if (mm < 10) mm = "0" + mm
    return yyyy + "-" + mm + "-" + dd
}
export const addDay = (value, day) => {
    return new Date(value.getTime() + day * 24 * 60 * 60 * 1000)
}
export const MyImage = (x) => {
    x = { ...x }
    return (
        <img
            style={x.style}
            src={loadImage(x.url, (res) => {
                if (x.image !== undefined) x.image.src = res
            })}
            alt={x.alt ?? ""}
            onLoad={(ev) => (x.image = ev.target)}
        />
    )
}
export function loadImage(url, complete, x) {
    x = {
        img: window.imageCollection.filter((e) => e.url === url)
    }
    if (x.img.length > 0) return x.img[0].image
    if (url.substr(0, 1) === "/") url = url.substr(1)
    x.i = window.imageCollection.length
    window.imageCollection.push({ url: url, image: baseUrl + "public/img/loading.gif" })
    http.get(baseUrl + "img/" + url, { responseType: "arraybuffer" }).then((response) => {
        response.image = Buffer.from(response.data).toString("base64")
        window.imageCollection[x.i].image = `data:image/png;base64, ${response.image}`
        if (typeof complete === "function") complete(window.imageCollection[x.i].image)
    })
    return window.imageCollection[x.i].image
}
export function url(url) {
    if (url.substr(0, 1) === "/") url = url.substr(1)
    return baseUrl + url
}
export function onRefresh(data, help) {
    help = {}
    if (data.object !== undefined) data.state = data.object.state
    if (data.state !== undefined) {
        help.link = data.state.info.id.split("_").join("/") + "/"
        data.url = help.link + "get"
        data.lastUpdate = data.state.lastUpdate
        data.dataSource = data.state.dataSource
        data.post = data.state.fn.post
    }
    if (data.lastUpdate === undefined) data.lastUpdate = null
    if (data.form === undefined) data.form = null
    data.post({
        url: data.url,
        data: {
            lastUpdate: data.lastUpdate,
            form: data.form
        },
        success: (e, x) => {
            if (e.deleted === undefined) e.deleted = []
            if (data.lastUpdate === null) {
                e.prepared = true
                help.success = e
                if (typeof data.success === "function") data.success(help.success)
            } else if (e.dataSource.length > 0 || e.deleted.length > 0) {
                x = { data: [...data.dataSource], i: 0, j: 0, k: 0 }
                for (x.i in e.deleted) {
                    x.getChanges = x.data.filter((expr) => expr.id === e.deleted[x.i].table_id)
                    if (x.getChanges.length > 0) for (x.j in x.getChanges) x.data.splice(x.data.indexOf(x.getChanges[x.j]), 1)
                }
                x.i = 0
                x.j = 0
                x.k = 0
                for (x.i in e.dataSource) {
                    x.getChanges = x.data.filter((expr) => expr.id === e.dataSource[x.i].id)
                    if (x.getChanges.length > 0)
                        for (x.j in e.dataSource[x.i]) for (x.k in x.getChanges) x.getChanges[x.k][x.j] = e.dataSource[x.i][x.j]
                    else x.data.push(e.dataSource[x.i])
                }
                help.success = {
                    dataSource: x.data,
                    lastUpdate: e.lastUpdate,
                    extra: e.extra
                }
                if (typeof data.success === "function") data.success(help.success, { e, x })
            } else if (e.extra !== undefined) {
                if (help.success === undefined) help.success = {}
                help.success.extra = e.extra
                if (typeof data.success === "function") data.success(help.success, { e })
            }
            if (help.success !== undefined) {
                if (data.object !== undefined) data.object.setState(help.success)
                if (data.state !== undefined) if (typeof data.state.changeChildState === "function") data.state.changeChildState(help.success)
            }
        }
    })
}
export function onStart(state) {
    state.continueSave = false
    if (state.childState !== undefined) {
        Object.keys(state.childState).forEach((key) => {
            state[key] = state.childState[key]
        })
        state.prepared = true
    } else {
        state.lastUpdate = null
        state.dataSource = []
        state.prepared = false
    }
    state.link = state.info.id.split("_").join("/") + "/"
    return state
}
export function onUpload(e, x, help) {
    help = {}
    if (x.object !== undefined) x.state = x.object.state
    if (x.state !== undefined) {
        help.link = x.state.info.id.split("_").join("/") + "/"
        x.url = help.link + "set"
        x.grid = x.state.grid
        x.post = x.state.fn.post
    }
    if (x.form === undefined) x.form = null
    x.post({
        url: x.url,
        data: {
            data: e.changes,
            form: x.form
        },
        success: (result) => {
            if (typeof result !== "object") result = { temp: result }
            result.i = 0
            for (result.i in result.update) {
                result.getChanges = e.changes.filter((expr) => expr.type === "insert" && expr.key === result.update[result.i].key)
                for (result.j in result.getChanges) {
                    result.getChanges[result.j].type = "update"
                    result.getChanges[result.j].key = result.update[result.i].id
                }
            }
            for (result.i in result.insert) {
                result.getChanges = e.changes.filter((expr) => expr.type === "insert" && expr.key === result.insert[result.i].key)
                for (result.j in result.getChanges) result.getChanges[result.j].data.id = result.insert[result.i].id
            }
            result.i = 0
            for (result.i in result.cancelUpdate) {
                result.getChanges = e.changes.filter((expr) => expr.key === result.cancelUpdate[result.i])
                for (result.j in result.getChanges) result.getChanges[result.j].type = "remove"
            }
            help.success = {
                continueSave: true,
                lastUpdate: result.lastUpdate
            }
            if (result.extra !== undefined) help.success.extra = result.extra
            if (x.object === undefined) x.success(help.success, result)
            else x.object.setState(help.success)
            if (x.grid !== undefined) x.grid.saveEditData()
        }
    })
}
export function onSaved(e, x) {
    x.object.setState({ continueSave: false })
}
export function onSaving(e, x) {
    if (x.object.state.continueSave) return
    if (x.object.state.grid.option("editing").mode === "batch") {
        x.confirm = confirm("<i>Are you sure?</i>", "Confirm changes")
        x.confirm.then((res) => {
            if (res) onUpload(e, { object: x.object })
        })
    } else {
        onUpload(e, { object: x.object })
    }
    e.cancel = true
}
export function onToolbarPreparing(e, x) {
    e.toolbarOptions.items.push({
        location: "before",
        widget: "dxButton",
        options: {
            icon: "xlsxfile",
            onClick: (e) => x.object.state.grid.exportToExcel(false)
        }
    })
    e.toolbarOptions.items.push({
        location: "before",
        widget: "dxButton",
        options: {
            icon: "refresh",
            onClick: () => onRefresh({ object: x.object })
        }
    })
}
export function timeDiff(e, x) {
    x = {}
    if (typeof e.date1 === "string") {
        x.pot = e.date1.split(" ")
        if (x.pot.length <= 1) e.date1 = "1900-01-01 ".e.date1
        e.date1 = new Date(e.date1)
    }
    if (typeof e.date2 === "string") {
        x.pot = e.date2.split(" ")
        if (x.pot.length <= 1) e.date2 = "1900-01-01 ".e.date2
        e.date2 = new Date(e.date2)
    }
    e.diff = e.date2.getTime() - e.date1.getTime()
    e.hh = Math.floor(e.diff / 1000 / 60 / 60)
    e.diff -= e.hh * 1000 * 60 * 60
    e.mm = Math.floor(e.diff / 1000 / 60)
    e.diff -= e.mm * 1000 * 60
    e.ss = Math.floor(e.diff / 1000)
    e.diff -= e.ss * 1000
    return e
}
